import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SpecialPromoDesktop } from '../../components/SpecialPromoDesktop';
import { selectPageType } from '../../selectors/page';
import { selectCurrentSpecialPromo } from '../../selectors/specialPromos';
import { trackSpecialPromoClick } from './tracking';

export function SpecialPromosDesktopContainer() {
  const pageType = useSelector(selectPageType);
  const currentSpecialPromo = useSelector(selectCurrentSpecialPromo);
  const isPik = useMemo(() => currentSpecialPromo?.name.toLocaleLowerCase() === 'пик', [currentSpecialPromo]);
  const handleSpecialPromoClick = React.useCallback(() => {
    if (!currentSpecialPromo) {
      return;
    }

    trackSpecialPromoClick(pageType, currentSpecialPromo.key);
  }, [currentSpecialPromo, pageType]);

  if (!currentSpecialPromo) {
    return null;
  }

  return (
    <SpecialPromoDesktop
      title={isPik ? '' : currentSpecialPromo.name}
      href={currentSpecialPromo.desktopUrl}
      logoUrl={currentSpecialPromo.desktopLogoUrl}
      isPik={isPik}
      onClick={handleSpecialPromoClick}
    />
  );
}
